<template>
  <div class="row">
    <div class="col-12">
      <div class="m-portlet">

        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <h3 class="m-portlet__head-text">
                Targets
              </h3>
            </div>
          </div>
        </div>

        <div class="m-portlet__body">
          <loader v-if="loading"></loader>
          <div v-else>
            <div>
              <line-chart
                v-if="chartData"
                :data="chartData"
                :options="chartOptions"
                yAxeLabel="Hours"></line-chart>
            </div>

            <hr>
            <div class="col-3 pl-4" style="display:flex;align-items: center;">
              Monthly target (€) &nbsp; <input type="text" class="form-control" style="width:auto; align-items: center;" v-model="monthlyTarget">
              <span class="btn btn-primary ml-2" @click="saveTarget">Save</span>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import LineChart from '../../components/charts/LineChart'

  export default {
    props: ['startDate', 'endDate'],
    components: {
      LineChart,
    },
    created() {
      this.load()
    },

    data() {
      return {
        monthlyTarget: null,
        loading: false,
        chartData: null,
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'EUR',
              },
              ticks: {
                beginAtZero: true
              },
            }]
          }
        }
      }
    },
    watch: {
      startDate: function () {
        this.load()
      }
    },
    methods: {
      load() {
        this.loading = true
        this.chartData = null

        this.axios.get('reports/targets', {params: {startDate: this.startDate, endDate: this.endDate}}).then(response => {
          this.chartData = response.data.data.chart
          this.monthlyTarget = response.data.data.monthlyTarget
          this.loading = false
          this.$forceUpdate()
        })
      },
      saveTarget() {
        this.loading = true
        this.axios.post('reports/targets/monthly/save', {
          startDate: this.startDate,
          endDate: this.endDate,
          monthlyTarget: this.monthlyTarget
        }).then(() => {
          this.load()
        }).catch(err => {
          this.load()
        })
      }
    }
  }
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/reports/Targets.vue